import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  saveSelectedNetwork,
  saveSelectedGroup,
} from "../redux/action/networks.action";
import OrganizationSelector from "./OrganizationSelector";
import NetworksSelector from "./NetworksSelector";
import { withTranslation } from "react-i18next";
import { ChevronIcon } from "../icons";
import { BASENAME } from "../constants/Globals";
import { afterSideBarNetworkChange, isSubscriptionFeatureLocked } from "../services/NetworkSvc";
import { showSubscriptionAlertPopup } from "../services/SubscriptionAlertPopupSvc";
import SvgElement from "./pages/debatePreviewV2/SvgElement";
import { isUserHasValidRoleForGroup } from "../services/GroupSvc";

class Aside extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedNetwork: "",
      // sideBar: window.innerWidth > 1200 ? "expanded" : "collapsed",
      sideBar: "expanded",
      currentURL: "",
      activeNavGroups: [],
      isFeatureLockCampaign: false,
      isFeatureLockAudienceInsight: false,
      isFeatureLockAudienceModeration: false,
    };
  }

  toggleSidebar = async (e) => {
    // await this.setState({
    // sideBar: this.state.sideBar === "expanded" ? "collapsed" : "expanded",
    // });

    this.props.parentCallback(this.state.sideBar);
  };

  reRender = async (action) => {
    if (action !== "notMenuClick") {
      this.toggleSidebarVisibility();
    }
    setTimeout(() => {
      this.setState({ currentURL: window.location.pathname });
    }, 200);
  };

  componentDidMount() {
    this.reRender("notMenuClick");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selNetworkId !== this.props.selNetworkId) {
      this.render();
      console.log('Loading selected network"s subscription features...');
      this.loadSelectedNetworkSubscriptionFeatures(this.props.selNetworkId);
    }
    if (
      prevProps.selGroupSlug !== null &&
      prevProps.selGroupSlug !== this.props.selGroupSlug
    ) {
      this.reRender("notMenuClick");
    }
  }

  toggleSidebarVisibility = async (e) => {
    document.body.classList.toggle("menuVisible");
  };

  filterNetworksDropdown = async (e) => {
    this.setState({ networkFilter: e.target.value });
  };

  filterGroupsDropdown = async (e) => {
    this.setState({ groupFilter: e.target.value });
  };

  focusMe = async ({ target }) => {
    setTimeout(() => {
      if (
        target.nextElementSibling &&
        target.nextElementSibling.firstElementChild &&
        target.nextElementSibling.firstElementChild.firstElementChild
      ) {
        target.nextElementSibling.firstElementChild.firstElementChild.focus();
      }
    }, 200);
  };

  onGroupToggle = (group) => {
    const { activeNavGroups } = this.state;

    const index = activeNavGroups.findIndex((gr) => gr === group);

    if (index !== -1) {
      activeNavGroups.splice(index, 1);
    } else {
      activeNavGroups.push(group);
    }

    this.setState({ activeNavGroups });
  };

  checkIfFeatureLocked = async () => {
    const isLoggedInUserSuperAdmin = await isUserHasValidRoleForGroup(0, "SUPERADMIN");
    if (!isLoggedInUserSuperAdmin) {
      this.state.isFeatureLockCampaign = await isSubscriptionFeatureLocked("campaigns");
      this.state.isFeatureLockAudienceInsight = await isSubscriptionFeatureLocked("audience-insights");
      this.state.isFeatureLockAudienceModeration = await isSubscriptionFeatureLocked("audience-moderation");
    }
  }

  loadSelectedNetworkSubscriptionFeatures = async (networkId) => {
    await afterSideBarNetworkChange(networkId);
    this.checkIfFeatureLocked();
  }

  handleAsideNetworkChange = async (networkId) => {
    this.props.saveSelectedNetwork(networkId, true);
    this.checkIfFeatureLocked();
  };

  render() {
    const { location } = window;
    const { pathname } = location;
    const { activeNavGroups } = this.state;
    const { networks, selNetworkId, selGroupSlug, loggedInUser, groups } =
      this.props;
    const { roles } = loggedInUser;
    const kTrans = this.props.t ? this.props.t : "";
    const isSuperAdmin =
      loggedInUser &&
      roles.length > 0 &&
      roles.find((role) => role.name === "SUPERADMIN");
    const isGroupAdmin =
      isSuperAdmin ||
      roles.find(
        ({ name, roleUser }) => name === "GROUPADMIN" && roleUser.groupId !== 0 &&  roleUser.clientId === parseInt(selNetworkId)
      );
    let isAdmin = isSuperAdmin || isGroupAdmin;
    let isEditor = false;
    let isModerator = false;

    if (
      roles.find(
        (role) =>
          role.name === "ADMIN" &&
          role.roleUser.clientId === parseInt(selNetworkId)
      )
    ) {
      isAdmin = true;
    } else {
      if (
        roles.find(
          (role) =>
            (role.name === "EDITOR" || role.name === "ADVERTISER") &&
            role.roleUser.clientId === parseInt(selNetworkId)
        )
      ) {
        isEditor = true;
      }
    }

    if (
      roles.find(
        (role) =>
          role.name === "MODERATOR" &&
          role.roleUser.clientId === parseInt(selNetworkId)
      )
    ) {
      if (pathname.indexOf("/moderation") === -1) {
        location.href = `${BASENAME}/moderation`;
      }
      isModerator = true;
    }

    return (
      <>
        <div className="toggleSidebarVisibility">
          <svg
            id="toggleSidebarVisibility"
            onClick={this.toggleSidebarVisibility}
            className="menuToggle"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
          >
            <path
              d="M24 12.8133L22.12 14.6667L15.44 8L22.12 1.33333L24 3.18667L19.2533 8L24 12.8133ZM0 0H17.3333V2.66667H0V0ZM0 9.33333V6.66667H13.3333V9.33333H0ZM0 16V13.3333H17.3333V16H0Z"
              fill="#BDBDBD"
            />
          </svg>
        </div>
        <aside>
          <nav className="menuCollapseToggle">
            <span>Menu</span>
            <span>
              <svg
                onClick={this.toggleSidebar}
                className="menuToggle"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
              >
                <path
                  d="M24 12.8133L22.12 14.6667L15.44 8L22.12 1.33333L24 3.18667L19.2533 8L24 12.8133ZM0 0H17.3333V2.66667H0V0ZM0 9.33333V6.66667H13.3333V9.33333H0ZM0 16V13.3333H17.3333V16H0Z"
                  fill="#BDBDBD"
                />
              </svg>
            </span>
          </nav>

          {isGroupAdmin && false ? (
            <>
              {groups && groups.length > 1 ? (
                <div className="current-network-section">
                  <OrganizationSelector
                    value={selGroupSlug}
                    onChange={(groupId, groupSlug) =>
                      this.props.saveSelectedGroup(groupSlug, true)
                    }
                  />
                </div>
              ) : null}

              {groups && groups.length === 1 ? (
                <div className="current-network-section">
                  <div className="standard-dropdown-label">
                    {groups[0].groupName}
                  </div>
                </div>
              ) : null}

              <nav className="leftMenu">
                <ul>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      className={
                        this.state.currentURL ===
                        "/organizations/" + selGroupSlug + "/analytics"
                          ? "active"
                          : ""
                      }
                      exact
                      activeClassName="active1"
                      to={`/organizations/${selGroupSlug}/analytics`}
                    >
                      <svg
                        width="29"
                        height="23"
                        viewBox="0 0 29 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.31441 2.9383C6.31441 4.07353 5.40108 4.99379 4.27536 4.99379C3.14921 4.99379 2.23632 4.07353 2.23632 2.9383C2.23632 1.80307 3.14921 0.882812 4.27536 0.882812C5.40108 0.882812 6.31441 1.80307 6.31441 2.9383ZM26.0252 2.25314C27.1509 2.25314 28.0642 3.1734 28.0642 4.30863V7.04928C28.0642 8.18408 27.1509 9.10477 26.0252 9.10477H12.4315C11.3058 9.10477 10.3925 8.18408 10.3925 7.04928V4.30863C10.3925 3.1734 11.3058 2.25314 12.4315 2.25314H26.0252ZM26.0252 4.30863H21.2674V7.04928H26.0252V4.30863ZM26.0252 14.5861C27.1509 14.5861 28.0642 15.5068 28.0642 16.6416V19.3822C28.0642 20.517 27.1509 21.4377 26.0252 21.4377H12.4315C11.3058 21.4377 10.3925 20.517 10.3925 19.3822V16.6416C10.3925 15.5068 11.3058 14.5861 12.4315 14.5861H26.0252ZM26.0252 16.6416H15.8299V19.3822H26.0252V16.6416ZM4.95504 6.36412C6.45459 6.36412 7.67377 7.59313 7.67377 9.10477C7.67377 9.86273 7.0663 10.4751 6.31441 10.4751H2.23632C1.48569 10.4751 0.876953 9.86273 0.876953 9.10477C0.876953 7.59313 2.09401 6.36412 3.59568 6.36412H4.95504ZM6.31441 15.2712C6.31441 16.406 5.40108 17.3267 4.27536 17.3267C3.14921 17.3267 2.23632 16.406 2.23632 15.2712C2.23632 14.1364 3.14921 13.2157 4.27536 13.2157C5.40108 13.2157 6.31441 14.1364 6.31441 15.2712ZM4.95504 18.697C6.45459 18.697 7.67377 19.9261 7.67377 21.4377C7.67377 22.1957 7.0663 22.808 6.31441 22.808H2.23632C1.48569 22.808 0.876953 22.1957 0.876953 21.4377C0.876953 19.9261 2.09401 18.697 3.59568 18.697H4.95504Z"
                          fill="#BDBDBD"
                        />
                      </svg>
                      <span>{kTrans("Analytics")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      className={
                        this.state.currentURL ===
                        "/organizations/" + selGroupSlug + "/advertising"
                          ? "active"
                          : ""
                      }
                      exact
                      activeClassName="active1"
                      to={`/organizations/${selGroupSlug}/advertising`}
                    >
                      <svg
                        width="32"
                        height="26"
                        viewBox="0 0 32 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8367 16.7192C16.023 17.1473 15.8367 17.6019 15.4225 17.8397C15.0032 18.03 14.5114 17.8397 14.325 17.4169L13.8022 16.2224H8.90495L8.3821 17.4169C8.14914 17.8397 7.70394 18.03 7.28462 17.8397C6.87048 17.6019 6.68411 17.1473 6.87048 16.7192L10.5978 8.26234C10.6858 7.96106 11.0274 7.76549 11.3536 7.76549C11.6797 7.76549 11.9748 7.96106 12.1094 8.26234L15.8367 16.7192ZM9.65041 14.531H13.0567L11.307 10.625L9.65041 14.531ZM22.5354 8.61118C22.5354 8.14605 22.9082 7.76549 23.3637 7.76549C23.8193 7.76549 24.192 8.14605 24.192 8.61118V17.068C24.192 17.5332 23.8193 17.9137 23.3637 17.9137C22.9703 17.9137 22.639 17.6336 22.5561 17.2583C21.9608 17.6706 21.1946 17.9137 20.4647 17.9137C18.4044 17.9137 16.7374 16.2118 16.7374 14.1081C16.7374 12.0045 18.4044 10.3026 20.4647 10.3026C21.2309 10.3026 21.9453 10.5404 22.5354 10.9421V8.61118ZM20.4647 11.9939C19.3206 11.9939 18.394 12.94 18.394 14.1081C18.394 15.2763 19.3206 16.2224 20.4647 16.2224C21.6088 16.2224 22.5354 15.2763 22.5354 14.1081C22.5354 12.94 21.6088 11.9939 20.4647 11.9939ZM1 4.38275C1 2.51431 2.48315 1 4.31314 1H27.5051C29.3326 1 30.8183 2.51431 30.8183 4.38275V21.2965C30.8183 23.1623 29.3326 24.6792 27.5051 24.6792H4.31314C2.48315 24.6792 1 23.1623 1 21.2965V4.38275ZM2.65657 4.38275V21.2965C2.65657 22.232 3.39841 22.9879 4.31314 22.9879H27.5051C28.4214 22.9879 29.1617 22.232 29.1617 21.2965V4.38275C29.1617 3.44879 28.4214 2.69137 27.5051 2.69137H4.31314C3.39841 2.69137 2.65657 3.44879 2.65657 4.38275Z"
                          fill="#BDBDBD"
                          stroke="#BDBDBD"
                          strokeWidth="0.877008"
                        />
                      </svg>
                      <span>{kTrans("Advertising")}</span>
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </>
          ) : null}

          {networks && networks.length > 1 ? (
            <div className="current-network-section">
              <NetworksSelector
                networks={networks}
                value={selNetworkId}
                onChange={this.handleAsideNetworkChange}
              />
            </div>
          ) : null}

          {networks && networks.length === 1 ? (
            <div className="current-network-section">
              <div className="standard-dropdown-label">
                {networks[0].header.title}
              </div>
            </div>
          ) : null}

          <nav className="leftMenu side-nav revolutionary">
            {isEditor || isAdmin ? (
              <>
                <div
                  className={`side-nav-trigger ${activeNavGroups.includes("content") ? "expanded" : ""} ${["/", "/questions", "/forms", "/sequences"].includes(pathname) ? "active" : ""}`}
                  onClick={() => this.onGroupToggle("content")}
                >
                  <span>
                    <figure>
                      <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        fill="none"
                        className="has-stroke"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.4392 8.61118H6.67371C6.20859 8.61118 5.82803 8.23062 5.82803 7.76549C5.82803 7.30037 6.20859 6.91981 6.67371 6.91981H13.4392C13.9043 6.91981 14.2849 7.30037 14.2849 7.76549C14.2849 8.23062 13.9043 8.61118 13.4392 8.61118ZM18.5133 11.9939C18.9785 11.9939 19.359 12.3745 19.359 12.8396C19.359 13.3047 18.9785 13.6853 18.5133 13.6853H6.67371C6.20859 13.6853 5.82803 13.3047 5.82803 12.8396C5.82803 12.3745 6.20859 11.9939 6.67371 11.9939H18.5133ZM10.0565 18.7594H6.67371C6.20859 18.7594 5.82803 18.3789 5.82803 17.9137C5.82803 17.4486 6.20859 17.068 6.67371 17.068H10.0565C10.5216 17.068 10.9021 17.4486 10.9021 17.9137C10.9021 18.3789 10.5216 18.7594 10.0565 18.7594ZM21.0504 1C22.9162 1 24.4331 2.51431 24.4331 4.38275V21.2965C24.4331 23.1623 22.9162 24.6792 21.0504 24.6792H4.13665C2.26821 24.6792 0.753906 23.1623 0.753906 21.2965V4.38275C0.753906 2.51431 2.26821 1 4.13665 1H21.0504ZM21.0504 2.69137H4.13665C3.2027 2.69137 2.44528 3.44879 2.44528 4.38275V21.2965C2.44528 22.232 3.2027 22.9879 4.13665 22.9879H21.0504C21.9859 22.9879 22.7418 22.232 22.7418 21.2965V4.38275C22.7418 3.44879 21.9859 2.69137 21.0504 2.69137Z"
                          fill="#BDBDBD"
                          stroke="#BDBDBD"
                          strokeWidth="0.877008"
                        />
                      </svg>
                    </figure>
                    <span>Content</span>
                  </span>
                  <ChevronIcon />
                </div>
                <ul>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/"
                    >
                      <span>{kTrans("Polls")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/questions"
                    >
                      <span>{kTrans("Questions")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/forms"
                    >
                      <span>{kTrans("Forms")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/sequences"
                    >
                      <span>{kTrans("Sequences")}</span>
                    </NavLink>
                  </li>
                </ul>
              </>
            ) : null}

            {isAdmin ? (
              <>
                <div
                  className={`side-nav-trigger ${activeNavGroups.includes("reports") ? "expanded" : ""} ${["/reports", "/reports/performance", "/reports/accounting", "/reports/accounting2"].includes(pathname) ? "active" : ""}`}
                  onClick={() => this.onGroupToggle("reports")}
                >
                  <span>
                    <figure>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 20V6H4V20H0ZM7 20V0H11V20H7ZM14 20V12H18V20H14Z"
                          fill="#2F80ED"
                        />
                      </svg>
                    </figure>
                    <span>Reports</span>
                  </span>

                  <ChevronIcon />
                </div>

                <ul>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/reports"
                    >
                      <span>{kTrans("Overview")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/reports/performance"
                    >
                      <span>{kTrans("Performance")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/reports/votes-audit"
                    >
                      <span>{kTrans("Votes Audit")}</span>
                    </NavLink>
                  </li>
                  {isSuperAdmin ? (
                    <>
                      <li>
                        <NavLink
                          onClick={this.reRender}
                          exact
                          activeClassName="active"
                          to="/reports/accounting"
                        >
                          <span>{kTrans("Accounting")}</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          onClick={this.reRender}
                          exact
                          activeClassName="active"
                          to="/reports/ai-usage"
                        >
                          <span>{kTrans("AI Usage")}</span>
                        </NavLink>
                      </li>
                    </>
                  ) : null}
                </ul>
              </>
            ) : null}

            {isAdmin || isModerator ? (
              <>
                <div
                  className={`side-nav-trigger ${activeNavGroups.includes("audience") ? "expanded" : ""} ${["/audience", "/audience/segments", "/moderation"].includes(pathname) ? "active" : ""}`}
                  onClick={() => this.onGroupToggle("audience")}
                >
                  <span>
                    <figure>
                      <svg
                        width="29"
                        height="22"
                        viewBox="0 0 29 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.0278 13.7033C16.5452 13.7033 18.5487 11.7094 18.5487 9.2497C18.5487 6.78996 16.5079 4.79614 14.0278 4.79614C11.5103 4.79614 9.50677 6.78996 9.50677 9.2497C9.46731 11.7077 11.5107 13.7033 14.0278 13.7033ZM14.0278 6.85163C15.3805 6.85163 16.4816 7.92733 16.4816 9.2497C16.4816 10.5721 15.3783 11.6478 14.0278 11.6478C12.6772 11.6478 11.5721 10.5729 11.5721 9.2497C11.5721 7.92648 12.6728 6.85163 14.0278 6.85163ZM22.4514 6.85163C24.3887 6.85163 25.9595 5.31772 25.9595 3.42581C25.9595 1.53391 24.3896 0 22.4514 0C20.5141 0 18.9434 1.53391 18.9434 3.42581C18.9434 5.31772 20.5132 6.85163 22.4514 6.85163ZM16.2203 15.0736H11.844C8.40174 15.0736 5.61285 17.6301 5.61285 20.7818C5.61285 21.4156 6.16975 21.9252 6.85821 21.9252H21.2061C21.8945 21.9252 22.4514 21.4156 22.4514 20.7818C22.4514 17.6301 19.6625 15.0736 16.2203 15.0736ZM7.80976 19.8697C8.26888 18.2956 9.88652 17.1291 11.8063 17.1291H16.2203C18.1396 17.1291 19.7572 18.2956 20.2168 19.8697H7.80976ZM24.2011 8.22195H21.4893C20.9281 8.22195 20.3983 8.35201 19.9169 8.57481C19.9432 8.80006 19.987 9.01846 19.987 9.2497C19.987 10.6933 19.4266 11.9993 18.5329 13.0181H27.2899C27.7179 13.0181 28.0643 12.6584 28.0643 12.2173C28.0643 10.0119 26.3366 8.22195 24.2011 8.22195ZM8.06409 9.2497C8.06409 9.01636 8.10717 8.79449 8.13465 8.56839C7.65628 8.31188 7.13008 8.22195 6.57318 8.22195H3.86235C1.72946 8.22195 0 10.0119 0 12.2173C0 12.6584 0.345848 13.0181 0.772645 13.0181H9.5208C8.62538 11.9989 8.06409 10.6928 8.06409 9.2497ZM5.61285 6.85163C7.55017 6.85163 9.12089 5.31772 9.12089 3.42581C9.12089 1.53391 7.55104 0 5.61285 0C3.67554 0 2.10482 1.53391 2.10482 3.42581C2.10482 5.31772 3.67554 6.85163 5.61285 6.85163Z"
                          fill="#BDBDBD"
                        />
                      </svg>
                    </figure>
                    <span>{kTrans("Audience")}</span>
                  </span>
                  <ChevronIcon />
                </div>

                <ul>
                  {isAdmin ? (
                    <>
                      <li>
                        <NavLink
                          onClick={this.reRender}
                          exact
                          activeClassName="active"
                          to="/audience"
                        >
                          <span>{kTrans("Contacts")}</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          onClick={this.reRender}
                          activeClassName="active"
                          to="/audience/segments"
                        >
                          <span>{kTrans("Segments")}</span>
                        </NavLink>
                      </li>
                    </>
                  ) : null}
                  {( isSuperAdmin || isGroupAdmin ) ? (
                    <li>
                      <NavLink
                        onClick={(e) => {
                          if (this.state.isFeatureLockAudienceInsight) {
                            e.preventDefault();
                            showSubscriptionAlertPopup({
                              title: 'Upgrade for Access',
                              messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                            });
                          } else {
                            this.reRender();
                          }
                        }}
                        exact
                        activeClassName="active"
                        to="/tags"
                      >
                        <span>
                          Tags
                          {this.state.isFeatureLockAudienceInsight ? 
                            (<span onClick={() => 
                                showSubscriptionAlertPopup({
                                title: 'Upgrade for Access',
                                messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                              })}>
                              <SvgElement name="lock-icon" />
                            </span>) : ""}
                        </span>
                      </NavLink>
                    </li>
                  ) : null}
                  <li>
                    <NavLink
                      onClick={(e) => {
                          if (this.state.isFeatureLockAudienceModeration) {
                            e.preventDefault();
                            showSubscriptionAlertPopup({
                              title: 'Upgrade for Access',
                              messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                            });
                          } else {
                            this.reRender();
                          }
                        }}
                      activeClassName="active"
                      to="/moderation"
                    >
                      <span>
                        Moderation{this.state.isFeatureLockAudienceModeration ? 
                        (<span onClick={() => 
                            showSubscriptionAlertPopup({
                            title: 'Upgrade for Access',
                            messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                          })}>
                          <SvgElement name="lock-icon" />
                        </span>)
                        : ""}
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </>
            ) : null}

            {isAdmin ? (
              <>
                <div
                  className={`side-nav-trigger ${activeNavGroups.includes("advertising") ? "expanded" : ""} ${["/advertising/ads"].includes(pathname) ? "active" : ""}`}
                  onClick={() => this.onGroupToggle("advertising")}
                >
                  <span>
                    <figure>
                      <svg
                        width="30"
                        height="27"
                        viewBox="0 0 30 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.75 1.6875C28.0573 1.6875 27.5 2.25176 27.5 2.95312V3.25371L2.5 10.1566V9.70312C2.5 9.00176 1.94271 8.4375 1.25 8.4375C0.557292 8.4375 0 9.00176 0 9.70312V10.8475V11.8125V15.1875V16.1525V17.2969C0 17.9982 0.557292 18.5625 1.25 18.5625C1.94271 18.5625 2.5 17.9982 2.5 17.2969V16.8434L8.625 18.5361C8.4375 19.074 8.33333 19.6488 8.33333 20.25C8.33333 23.0449 10.5729 25.3125 13.3333 25.3125C15.776 25.3125 17.8125 23.5406 18.2448 21.1939L27.5 23.7463V24.0469C27.5 24.7482 28.0573 25.3125 28.75 25.3125C29.4427 25.3125 30 24.7482 30 24.0469V22.7812V4.21875V2.95312C30 2.25176 29.4427 1.6875 28.75 1.6875ZM27.5 21.1254L2.5 14.2225V12.7775L27.5 5.87461V21.1254ZM10.8333 20.25C10.8333 19.8756 10.9115 19.5223 11.0573 19.2059L15.8229 20.5189C15.6875 21.7898 14.625 22.776 13.3385 22.776C11.9583 22.776 10.8385 21.6422 10.8385 20.2447L10.8333 20.25Z"
                          fill="#BDBDBD"
                        />
                      </svg>
                    </figure>
                    <span>{kTrans("Advertising")}</span>
                  </span>
                  <ChevronIcon />
                </div>

                <ul>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/advertising/ads"
                    >
                      <span>{kTrans("Ads.txt")}</span>
                    </NavLink>
                  </li>
                  {isSuperAdmin || isGroupAdmin ? (
                    <li>
                      <NavLink
                        onClick={(e) => {
                          if (this.state.isFeatureLockCampaign) {
                            e.preventDefault();
                            showSubscriptionAlertPopup({
                              title: 'Upgrade for Access',
                              messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                            });
                          } else {
                            this.reRender();
                          }
                        }}
                        exact
                        activeClassName="active"
                        to="/campaigns"
                      >
                        <span>
                          {"Campaigns"}{this.state.isFeatureLockCampaign ? 
                            (<span onClick={() => 
                                showSubscriptionAlertPopup({
                                title: 'Upgrade for Access',
                                messageStr: 'Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.'
                              })}>
                              <SvgElement name="lock-icon" />
                            </span>)
                          : ""}
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>

                <div
                  className={`side-nav-trigger ${activeNavGroups.includes("settings") ? "expanded" : ""} ${["/network/users", "/network/settings", "/network/integration", "/network/categories", "/network/admin", "/global-settings"].includes(pathname) || pathname.includes("groups/") ? "active" : ""}`}
                  onClick={() => this.onGroupToggle("settings")}
                >
                  <span>
                    <figure>
                      <svg
                        width="26"
                        height="27"
                        viewBox="0 0 26 27"
                        fill="none"
                        className="has-stroke"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.0827 15.4459L22.4654 14.5122C22.5671 13.707 22.5671 12.8922 22.4654 12.087L24.0827 11.1533C24.5576 10.8792 24.7867 10.3151 24.6305 9.7894C24.0744 7.91722 23.0844 6.23202 21.777 4.84995C21.3984 4.44971 20.7942 4.36213 20.3171 4.63758L18.7022 5.56987C18.0562 5.07827 17.3507 4.67034 16.6024 4.35578V2.4903C16.6024 1.9383 16.2229 1.45852 15.6856 1.3314C13.8187 0.889557 11.8609 0.889508 9.99358 1.3314C9.45642 1.45852 9.07686 1.93825 9.07686 2.4903V4.35578C8.32854 4.67032 7.623 5.07826 6.97705 5.56987L5.36212 4.63758C4.88496 4.36213 4.28074 4.44971 3.90218 4.84995C2.59485 6.23202 1.60488 7.91727 1.04871 9.7894C0.892537 10.3151 1.12162 10.8791 1.59654 11.1533L3.21385 12.087C3.11218 12.8922 3.11218 13.707 3.21385 14.5122L1.59654 15.4459C1.12162 15.7201 0.892537 16.2842 1.04871 16.8099C1.60488 18.682 2.59485 20.3672 3.90218 21.7493C4.28079 22.1496 4.88501 22.2371 5.36212 21.9617L6.97705 21.0294C7.62299 21.521 8.32853 21.929 9.07686 22.2435V24.109C9.07686 24.661 9.45637 25.1407 9.99358 25.2679C11.8606 25.7097 13.8183 25.7098 15.6856 25.2679C16.2228 25.1407 16.6024 24.661 16.6024 24.109V22.2435C17.3507 21.9289 18.0562 21.521 18.7022 21.0294L20.3171 21.9617C20.7942 22.2372 21.3984 22.1496 21.777 21.7493C23.0844 20.3672 24.0744 18.682 24.6305 16.8099C24.7867 16.2842 24.5576 15.7202 24.0827 15.4459ZM20.8352 20.4283L18.5385 19.1022C17.2 20.2464 16.7254 20.5343 15.0153 21.1385V23.7908C13.58 24.0869 12.0993 24.0869 10.6639 23.7908V21.1385C8.99647 20.5494 8.51371 20.2758 7.14071 19.1022L4.844 20.4283C3.86647 19.3328 3.12358 18.0483 2.66532 16.6612L4.96303 15.335C4.63892 13.5785 4.63877 13.0217 4.96303 11.2643L2.66532 9.93808C3.12358 8.55095 3.86652 7.26643 4.844 6.17037L7.14071 7.49754C8.49848 6.33533 8.97886 6.05606 10.6639 5.46071V2.80845C12.0992 2.51187 13.58 2.51187 15.0153 2.80845V5.46076C16.7005 6.05615 17.1809 6.33547 18.5385 7.49759L20.8352 6.17042C21.8127 7.26643 22.5556 8.55095 23.0139 9.93813L20.7162 11.2643C21.0404 13.0213 21.0405 13.5776 20.7162 15.3351L23.0139 16.6612C22.5556 18.0483 21.8128 19.3328 20.8352 20.4283ZM12.8396 8.5385C10.2143 8.5385 8.07846 10.6743 8.07846 13.2997C8.07846 15.925 10.2143 18.0608 12.8396 18.0608C15.4649 18.0608 17.6008 15.925 17.6008 13.2997C17.6008 10.6743 15.4649 8.5385 12.8396 8.5385ZM12.8396 16.4738C11.0894 16.4738 9.66551 15.0499 9.66551 13.2997C9.66551 11.5494 11.0894 10.1256 12.8396 10.1256C14.5898 10.1256 16.0137 11.5494 16.0137 13.2997C16.0137 15.0499 14.5898 16.4738 12.8396 16.4738Z"
                          fill="#BDBDBD"
                          stroke="#BDBDBD"
                          strokeWidth="0.877008"
                        />
                      </svg>
                    </figure>
                    <span>{kTrans("Settings")}</span>
                  </span>
                  <ChevronIcon />
                </div>

                <ul>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/network/users"
                    >
                      <span>{kTrans("Users")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/network/settings"
                    >
                      <span>{kTrans("Network")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/network/integration"
                    >
                      <span>{kTrans("Integration")}</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={this.reRender}
                      exact
                      activeClassName="active"
                      to="/network/categories"
                    >
                      <span>{kTrans("Categories")}</span>
                    </NavLink>
                  </li>

                  {isGroupAdmin ? (
                    <li>
                      <NavLink
                        onClick={this.reRender}
                        className={
                          this.state.currentURL ===
                          "/organizations/" + selGroupSlug + "/networks"
                            ? "active"
                            : ""
                        }
                        activeClassName="active1"
                        to={`/organizations/${selGroupSlug}/networks`}
                      >
                        <span>{kTrans("Organization")}</span>
                      </NavLink>
                    </li>
                  ) : null}

                  {isSuperAdmin ? (
                    <li>
                      <NavLink
                        onClick={this.reRender}
                        exact
                        activeClassName="active"
                        to="/network/admin"
                      >
                        <span>{kTrans("Admin")}</span>
                      </NavLink>
                    </li>
                  ) : null}

                  {isSuperAdmin ? (
                    <li>
                      <NavLink
                        onClick={this.reRender}
                        exact
                        activeClassName="active"
                        to="/global-settings"
                      >
                        <span>{kTrans("Global Settings")}</span>
                      </NavLink>
                    </li>
                  ) : null}

                  {isSuperAdmin ? (
                    <li>
                      <NavLink
                        onClick={this.reRender}
                        exact
                        activeClassName="active"
                        to="/ai-prompts"
                      >
                        <span>{kTrans("AI prompts")}</span>
                      </NavLink>
                    </li>
                  ) : null}
                </ul>
              </>
            ) : null}
          </nav>
        </aside>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  networks: state.networks.networksList,
  selNetworkId: state.networks.selNetworkId,
  selGroupSlug: state.networks.selGroupSlug,
  loggedInUser: state.login.user,
  groups: state.networks.groupsList,
});

const Extended = withTranslation()(Aside);
Extended.static = Aside.static;

export default connect(mapStateToProps, {
  saveSelectedNetwork,
  saveSelectedGroup,
})(Extended);
